import { CondicaoMaternalDbEnum, OrigemDadoEnum, SexoEnum } from 'graphql/types.generated'
import { Fragment } from 'react'

import { CondicoesFormModel } from '../model'
import { SubModalVacinacaoOptions } from '../VacinacaoModal'
import { AprazamentoDose } from './AprazamentoDose'
import { RegistroAnteriorDoseAccordionItem } from './RegistroAnteriorDoseAccordionItem'
import { RegistroDoseAccordionItem } from './RegistroDoseAccordionItem'

// dates as strings just for now
export interface RegistroDoseWrapperProps {
  index?: number
  idUnicoRegistro?: ID
  imunobiologicoId: string
  doseId: string
  doseNome: string
  doseSigla: string
  dataRegistro: string
  dataAplicacao?: string
  dataValidadeLote: string
  estrategia: string
  nomeProfissional: string
  cbo: string
  dataAprazamento: string
  lote: string
  nomeFabricante: string
  siglaFabricante?: string
  viaDeAdministracao: string
  localDaAplicacao: string
  observacoes: string
  condicaoMaternal: CondicaoMaternalDbEnum
  isViajante: boolean
  isComunicanteHanseniase: boolean
  grupoAtendimento?: string
  unidadeSaude: string
  origemDados: OrigemDadoEnum
  openedAccordions?: (string | number)[]
  registradoAtendimento: boolean
  condicoesVacinacao: CondicoesFormModel
  idUnicoRegistroAprazamentoProxDose?: ID
  idUnicoRegistroAplicacaoProxDose?: ID
  isAplicadoExterior?: boolean
  isAplicacaoEquivalente?: boolean
  handleOnDelete?(
    idUnicoRegistro: ID,
    tipoModal: SubModalVacinacaoOptions,
    idUnicoRegistroAprazamentoProxDose?: ID
  ): void
  handleOnEdit?(idUnicoRegistro: ID, tipoModal: SubModalVacinacaoOptions): void
  readOnly?: boolean
  isRegistroAnterior: boolean
  isCovid: boolean
  hasOnlyEquivalentesAplicadas: boolean
  cid10MotivoIndicacao: string
  cid10MotivoIndicacaoCodigoCid: string
  cboPrescritor: string
  isPesquisaClinica: boolean
  anvisaProtocoloEstudo: string
  anvisaProtocoloVersao: string
  anvisaNumeroRegistro: string
  sexoIdentidadeGenero: SexoEnum
  nomeImunobiologico?: string
}

export const RegistroDoseWrapper = (props: RegistroDoseWrapperProps) => {
  const { index, isRegistroAnterior, dataAplicacao } = props

  return (
    <Fragment>
      {isRegistroAnterior || dataAplicacao ? (
        isRegistroAnterior ? (
          <RegistroAnteriorDoseAccordionItem hasOnlyEquivalentesAplicadas {...props} />
        ) : (
          <RegistroDoseAccordionItem hasOnlyEquivalentesAplicadas {...props} />
        )
      ) : (
        <AprazamentoDose key={index} {...props} />
      )}
    </Fragment>
  )
}
